import React, { useState } from 'react';
import Button from '../../../../../component/ui/Button';
import arrow from '../../../../../assets/image/arrowD.svg';
import DatePicker from 'react-datepicker';
import Table from '../../../../../component/table/Table';
import ScheduleReportModal from '../../components/scheduleReportModal';
import { getCurrentDate } from '../../../../../utils/dateUtils';
export default function SaleByCustomers({ activeTab }) {
	const [dateRange, setDateRange] = useState('This Month');
	const [showOptions, setShowOptions] = useState(false);
	const [isCustomDateOpen, setIsCustomDateOpen] = useState(false);
	const [isFilterOpen, setIsFilterOpen] = useState(false);
	const [loaderScheduleReport, setLoaderScheduleReport] = useState(false);
	const [isScheduleModelOpen, setIsScheduleModelOpen] = useState(false);
	const [CustomDateRange, setCustomDateRange] = useState([null, null]);
	const [filterType, setFilterType] = useState('Invoice');
	const [scheduleParams, setScheduleParams] = useState({
		frequency_name: '',
		start_date: getCurrentDate(),
		hours: '',
		minutes: '',
		email_reciepient: '',
		customer_notes: '',
		pdf: false,
		csv: false,
		xls: false,
	});

	const [startDate, endDate] = CustomDateRange;

	const handleSaveScheduleReport = () => {};
	const transactions = [
		{
			DATE: '15/05/24',
			'CUSTOMER NAME': 'Lorem Ipsum',
			'TRANSACTION DETAILS': 'Lorem Ipsum',
			AMOUNT: 1000,
			'CR/DR': 'CR',
			BALANCE: 1000,
		},
		{
			DATE: '15/05/24',
			'CUSTOMER NAME': 'Lorem Ipsum',
			'TRANSACTION DETAILS': 'Lorem Ipsum',
			AMOUNT: 1000,
			'CR/DR': 'CR',
			BALANCE: 1000,
		},
		{
			DATE: '15/05/24',
			'CUSTOMER NAME': 'Lorem Ipsum',
			'TRANSACTION DETAILS': 'Lorem Ipsum',
			AMOUNT: 1000,
			'CR/DR': 'CR',
			BALANCE: 1000,
		},
		{
			DATE: '15/05/24',
			'CUSTOMER NAME': 'Lorem Ipsum',
			'TRANSACTION DETAILS': 'Lorem Ipsum',
			AMOUNT: 1000,
			'CR/DR': 'CR',
			BALANCE: 50000,
		},
		{
			DATE: '15/05/24',
			'CUSTOMER NAME': 'Lorem Ipsum',
			'TRANSACTION DETAILS': 'Lorem Ipsum',
			AMOUNT: 1000,
			'CR/DR': 'CR',
			BALANCE: 50000,
		},
		{
			DATE: '15/05/24',
			'CUSTOMER NAME': 'Lorem Ipsum',
			'TRANSACTION DETAILS': 'Lorem Ipsum',
			AMOUNT: 1000,
			'CR/DR': 'CR',
			BALANCE: 50000,
		},
		{
			DATE: '15/05/24',
			'CUSTOMER NAME': 'Lorem Ipsum',
			'TRANSACTION DETAILS': 'Lorem Ipsum',
			AMOUNT: 1000,
			'CR/DR': 'CR',
			BALANCE: 50000,
		},
		{
			DATE: '15/05/24',
			'CUSTOMER NAME': 'Lorem Ipsum',
			'TRANSACTION DETAILS': 'Lorem Ipsum',
			AMOUNT: 1000,
			'CR/DR': 'CR',
			BALANCE: 50000,
		},
		{
			DATE: '15/05/24',
			'CUSTOMER NAME': 'Lorem Ipsum',
			'TRANSACTION DETAILS': 'Lorem Ipsum',
			AMOUNT: 1000,
			'CR/DR': 'CR',
			BALANCE: 50000,
		},
		{
			DATE: '15/05/24',
			'CUSTOMER NAME': 'Lorem Ipsum',
			'TRANSACTION DETAILS': 'Lorem Ipsum',
			AMOUNT: 1000,
			'CR/DR': 'CR',
			BALANCE: 50000,
		},
		{
			DATE: '15/05/24',
			'CUSTOMER NAME': 'Lorem Ipsum',
			'TRANSACTION DETAILS': 'Lorem Ipsum',
			AMOUNT: 1000,
			'CR/DR': 'CR',
			BALANCE: 50000,
		},
		{
			DATE: '15/05/24',
			'CUSTOMER NAME': 'Lorem Ipsum',
			'TRANSACTION DETAILS': 'Lorem Ipsum',
			AMOUNT: 1000,
			'CR/DR': 'CR',
			BALANCE: 50000,
		},
		{
			DATE: '15/05/24',
			'CUSTOMER NAME': 'Lorem Ipsum',
			'TRANSACTION DETAILS': 'Lorem Ipsum',
			AMOUNT: 1000,
			'CR/DR': 'CR',
			BALANCE: 50000,
		},
		{
			DATE: '15/05/24',
			'CUSTOMER NAME': 'Lorem Ipsum',
			'TRANSACTION DETAILS': 'Lorem Ipsum',
			AMOUNT: 1000,
			'CR/DR': 'CR',
			BALANCE: 50000,
		},
		{
			DATE: '15/05/24',
			'CUSTOMER NAME': 'Lorem Ipsum',
			'TRANSACTION DETAILS': 'Lorem Ipsum',
			AMOUNT: 1000,
			'CR/DR': 'CR',
			BALANCE: 50000,
		},
		{
			DATE: '15/05/24',
			'CUSTOMER NAME': 'Lorem Ipsum',
			'TRANSACTION DETAILS': 'Lorem Ipsum',
			AMOUNT: 1000,
			'CR/DR': 'CR',
			BALANCE: 50000,
		},
	];

	const columns = [
		{
			field: 'DATE',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 50,
			flex: 1,
			cellStyle: { color: '#555B67' },
			headerStyle: { color: '#555B67' },
		},
		{
			field: 'CUSTOMER NAME',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			flex: 1,
			cellStyle: { color: '#555B67' },
			headerStyle: { color: '#555B67' },
		},
		{
			field: 'TRANSACTION DETAILS',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 300,
			flex: 1,
		},
		{
			field: 'AMOUNT',
			suppressSizeToFit: true,
			minWidth: 40,
			flex: 1,
			cellClass: 'right-align',
			headerClass: 'HeaderBg right-align',
		},
		{
			field: 'CR/DR',
			suppressSizeToFit: true,
			minWidth: 40,
			flex: 1,
			cellRenderer: (params) => (
				<span style={{ color: params.value === 'CR' ? 'green' : 'red' }}>{params.value}</span>
			),
			cellClass: 'right-align',
			headerClass: 'HeaderBg right-align',
		},
		{
			field: 'BALANCE',
			suppressSizeToFit: true,
			minWidth: 70,
			flex: 1,
			cellClass: 'right-align',
			headerClass: 'HeaderBg right-align',
		},
	];

	const handleOptionClick = (option) => {
		setDateRange(option);
		setShowOptions(false);
	};
	const handleFilter = (type) => {
		setFilterType(type);
		setIsFilterOpen(false);
	};
	return (
		<div>
			<div>
				<div style={{ backgroundColor: '#EDEDF7', position: 'sticky', top: 0, zIndex: 100 }}>
					<div className="d-flex py-4 px-2 justify-content-between align-items-center">
						<div className="d-flex gap-3 align-items-center">
							<div className="fs-3 fw-bold">{activeTab}</div>
							<div className="fs-4 fw-semibold">
								{'(from '}
								<b>01/04/2023</b> to <b>31/03/2024</b>
								{')'}
							</div>
						</div>
						<div className="d-flex gap-3 align-items-center">
							<Button
								type="button"
								className="btn-gray mt-0 px-4"
								button="Schedule Report"
								onClick={() => setIsScheduleModelOpen(true)}
							/>
							<Button
								type="button"
								className="btn-gray mt-0 px-4"
								button="Print/Download"
								onClick={() => {}}
							/>
							<Button
								type="button"
								className="btn-gray mt-0 px-4"
								button="Send Email"
								onClick={() => {}}
							/>
							<Button
								type="button"
								className="btn-gray mt-0 px-4"
								button="Export to Excel"
								onClick={() => {}}
							/>
						</div>
					</div>
				</div>
				<div className="d-flex gap-3 m-4">
					<div
						className="d-flex align-items-center justify-content-center"
						style={{
							border: '1px solid #DADDEC',
							borderRadius: '6px',
							width: '200px',
							position: 'relative',
							paddingLeft: '7px',
						}}
					>
						<div style={{ ...styles.label }}>Date Range:</div>
						<div onClick={() => setShowOptions(!showOptions)}>
							<div
								style={styles.dropdown}
								className="fw-bold gap-3"
							>
								{dateRange}
								<span
									style={{
										...styles.arrow,
										transform: showOptions ? 'rotate(180deg)' : 'rotate(0deg)',
									}}
								>
									{' '}
									<img
										src={arrow}
										alt=""
									/>
								</span>
								{/* Arrow rotation logic */}
							</div>
							{showOptions && (
								<div style={styles.optionsContainer}>
									{[
										'This Month',
										'This Week',
										'Quarter',
										'This Year',
										'Financial Year',
										'Custom Date',
									].map((option) => (
										<div
											key={option}
											style={styles.option}
											onClick={() => {
												if (option === 'Custom Date') {
													setIsCustomDateOpen(true);
												} else {
													setIsCustomDateOpen(false);
												}
												handleOptionClick(option);
											}}
										>
											{option}
										</div>
									))}
								</div>
							)}
						</div>
					</div>
					{isCustomDateOpen && (
						<div
							style={{
								width: '200px',
								backgroundColor: '#ffff',
							}}
						>
							<DatePicker
								placeholderText="Select date range"
								selectsRange={true}
								startDate={startDate}
								endDate={endDate}
								onChange={(update) => setCustomDateRange(update)}
								isClearable={true}
								maxDate={new Date()}
							/>
						</div>
					)}
					<div
						className="d-flex align-items-center justify-content-center gap-3"
						style={{
							border: '1px solid #DADDEC',
							borderRadius: '6px',
							position: 'relative',
							paddingLeft: '7px',
						}}
					>
						<div style={{ ...styles.label }}>Fiter:</div>
						<div onClick={() => setIsFilterOpen(!isFilterOpen)}>
							<div
								style={styles.dropdown}
								className="fw-bold gap-3"
							>
								{filterType}
								<span
									style={{
										...styles.arrow,
										transform: isFilterOpen ? 'rotate(180deg)' : 'rotate(0deg)',
									}}
								>
									{' '}
									<img
										src={arrow}
										alt=""
									/>
								</span>
								{/* Arrow rotation logic */}
							</div>
							{isFilterOpen && (
								<div style={styles.optionsContainer}>
									{['Invoice', 'Credit Note'].map((option) => (
										<div
											key={option}
											style={styles.option}
											onClick={() => {
												handleFilter(option);
											}}
										>
											{option}
										</div>
									))}
								</div>
							)}
						</div>
					</div>
				</div>
				<div style={styles.centerText}>
					<h2>{activeTab}</h2>
					<p>from 01/04/2023 to 31/03/2024</p>
				</div>
				<div style={styles.tableContainer}>
					<Table
						coloum={columns}
						row={transactions}
						onRowClick={() => {}}
						style={{ height: 'calc(100vh - 252px)' }}
					/>
				</div>
			</div>
			{isScheduleModelOpen && (
				<ScheduleReportModal
					isScheduleModelOpen={isScheduleModelOpen}
					setIsScheduleModelOpen={setIsScheduleModelOpen}
					activeTab={activeTab}
					scheduleParams={scheduleParams}
					setScheduleParams={setScheduleParams}
					loaderScheduleReport={loaderScheduleReport}
				/>
			)}
		</div>
	);
}
const styles = {
	container: {
		padding: '20px',
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: '20px',
	},
	label: {
		fontSize: '13px',
		color: '#555B67',
	},
	dropdown: {
		padding: '5px',
		fontSize: '12px',
		border: 'none',
		outline: 'none',
		cursor: 'pointer',
		display: 'flex',
		justifyContent: 'space-evenly',
		alignItems: 'center',
	},
	arrow: {
		margin: '0',
		transition: 'transform 0.2s ease',
	},
	optionsContainer: {
		position: 'absolute',
		top: '90%',
		left: 0,
		width: '170px',
		backgroundColor: '#fff',
		border: '1px solid #DADDEC',
		borderRadius: '4px',
		zIndex: 1,

		marginTop: '10px',
	},
	option: {
		padding: '8px',
		cursor: 'pointer',
		backgroundColor: '#F6F6F9',
		borderRadius: '4px',
		'&:hover': {
			backgroundColor: '#f0f0f0',
		},
	},
	buttons: {
		display: 'flex',
		gap: '10px',
	},
	centerText: {
		textAlign: 'center',
		marginBottom: '20px',
	},
	tableContainer: {
		width: '90%',
		margin: '0 auto',
		minHeight: '252px',
		overflowY: 'auto',
	},
};
